//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Centrifuge from 'centrifuge'
import CoinsTableMobile from '~/components/landing/coins_table_mobile'
import CoinsTable from '~/components/partials/coins_table'
export default {
  name: 'ListSection',
  components: {
    CoinsTableMobile,
    CoinsTable
  },
  props: {
    coinsPage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currencyType: this.$var.TMN,
      currencyList: [this.$var.TMN, this.$var.USDT],
      coinTypes: [this.$var.all, this.$var.trends, this.$var.topGain],
      moreTypes: ['internalWallet', 'topGain', 'topLose'],
      selectedCoinType: this.$var.all,
      centri: null,
      timer: 0,
      timerInterval: null,
      stateForCentrifuge: null,
      page: 1
    }
  },
  computed: {
    ...mapGetters({
      coins: 'coins/coins',
      trends: 'coins/trends',
      latest: 'coins/latest',
      loser: 'coins/loser',
      gainer: 'coins/gainer',
      assetsComplete: 'coins/assetsComplete'
    }),
    wantedCoinsList () {
      if (this.selectedCoinType === this.$var.all) {
        return this.coins
      } else if (this.selectedCoinType === this.$var.selected) {
        return this.$store.getters['watchList/watchList']
      } else if (this.selectedCoinType === this.$var.new) {
        return this.latest
      } else if (this.selectedCoinType === this.$var.trends) {
        return this.trends
      } else if (this.selectedCoinType === 'internalWallet') {
        return this.assetsComplete
      } else if (this.selectedCoinType === 'topGain') {
        return this.gainer
      } else if (this.selectedCoinType === 'topLose') {
        return this.loser
      }
      return []
    },
    wantedState () {
      if (this.selectedCoinType === this.$var.all) {
        return 'coins'
      } else if (this.selectedCoinType === this.$var.selected) {
        return 'watchList'
      } else if (this.selectedCoinType === this.$var.new) {
        return 'latest'
      } else if (this.selectedCoinType === 'internalWallet') {
        return 'assetsComplete'
      } else if (this.selectedCoinType === 'topGain') {
        return 'gainer'
      } else if (this.selectedCoinType === 'topLose') {
        return 'loser'
      }
      return []
    }
  },
  watch: {
    selectedCoinType (val) {
      if (val === this.$var.new && (this.latest.length === 0)) {
        // this.$store.dispatch('axios/get', { url: '/application/coin/latest', config: { baseURL: process.env.BASE_URL_UUID } })
        //   .then(async (res) => {
        //     await this.$store.dispatch('axios/get', {
        //       url: window.location.origin + '/fapi/coinsFilter',
        //       config: { params: { symbols: res.data.data.symbols.slice(0, 10).toString() } }
        //     })
        //       .then((resp) => {
        //         this.$store.commit('coins/set_data', {
        //           stateName: 'latest',
        //           data: resp.data.data
        //         })
        //       }).catch((e) => {
        //         return e
        //       })
        //   }).catch((e) => {
        //     return e
        //   })
      } else if (val === this.$var.selected && this.$store.getters['auth/isGuest']) {
        const router = this.$router.resolve({ path: '/my/auth/login' })
        window.open(router.href, '_self')
      }
    },
    async page () {
      await this.$store.dispatch('coins/getCoins', { limit: 100, offset: (this.page - 1) * 100, baseURL: window.location.origin })
    }
  },
  mounted () {
    this.timerInterval = setInterval(() => {
      this.timer += 1
    }, 1000)
    this.centri = new Centrifuge('wss://ticker-v3.arzypto.com/live')
    this.centrifuge()
  },
  beforeDestroy () {
    if (this.centri) {
      this.centri.disconnect()
    }
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }
  },
  methods: {
    centrifuge () {
      this.centri.subscribe('ticker:ccp', (msg) => {
        if (this.timer % 10 === 0) {
          for (const coinKey in msg.data) {
            const coinIndex = this.wantedCoinsList.findIndex(coin => (coinKey.includes('-') ? coinKey.split('-').join(' ') : coinKey) === coin.name.toLowerCase())
            if (coinIndex !== -1) {
              if (this.wantedState !== 'watchList') {
                this.$store.commit('coins/set_centrifuge', { stateName: this.wantedState, index: coinIndex, data: msg.data[coinKey] })
              } else {
                this.$store.commit('watchList/set_centrifuge', { index: coinIndex, data: msg.data[coinKey] })
              }
            }
          }
        }
      })
      this.centri.connect()
      this.centri.on('disconnect', () => {
        this.centri.connect()
      })
    },
    prevOrNext (type) {
      this.page = this.page + (type === 'prev' ? -1 : 1)
    }
  }
}
